import React from 'react';

const Nav = ({ children }) => <nav className="ws-ui-editor-header__nav">{children}</nav>;

export default Nav;
